import { ColorCoords, ColorScheme } from "./types";

export const getDefaultColorscheme = (width: number): ColorScheme => {
  const midtone: ColorCoords = { x: Math.round(width / 2), y: 210 };
  const second: ColorCoords = { x: midtone.x + 50, y: midtone.y + 50 };
  const first: ColorCoords = { x: midtone.x - 50, y: midtone.y - 50 };
  const retval = { first, midtone, second };
  return retval;
};
